export default "__VITE_ASSET__9I3fWKGJ__"